import { ReactNode, createContext, useContext, useEffect, useMemo, useState } from 'react'

type Theme = 'light' | 'dark'
type Ctx = { theme: Theme; setTheme: (t: Theme) => void; toggle: () => void }

const KEY = 'capexia.theme'
const ThemeCtx = createContext<Ctx | null>(null)

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setThemeState] = useState<Theme>(() => (localStorage.getItem(KEY) as Theme) || 'light')
  useEffect(() => {
    localStorage.setItem(KEY, theme)
    document.documentElement.setAttribute('data-theme', theme)
  }, [theme])
  const value = useMemo<Ctx>(() => ({ theme, setTheme: setThemeState, toggle: () => setThemeState((t) => (t === 'light' ? 'dark' : 'light')) }), [theme])
  return <ThemeCtx.Provider value={value}>{children}</ThemeCtx.Provider>
}

export function useTheme() {
  const v = useContext(ThemeCtx)
  if (!v) throw new Error('useTheme must be used within ThemeProvider')
  return v
}

